import React, { Component } from "react";
import "./WeightBenefitsTabs.css";
import _ from "lodash";

class WeighBenefitsTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if (!_.isEmpty(this.props.benefitsData)) {
      this.setState({
        data: this.props.benefitsData
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.benefitsData)) {
      this.setState({
        data: nextProps.benefitsData
      });
    }
  }

  elementInfiniteLoad() {
    return (
      <div className="col-sm-12">
        <div className="spinner3">
          <div className="rect1" />
          <div className="rect2" />
          <div className="rect3" />
          <div className="rect4" />
          <div className="rect5" />
        </div>
      </div>
    );
  }

  countWT(groupId, segmentId) {
    let wt = 0;
    for (let i of this.props.competeData) {
      if (groupId === i.groupId && segmentId === i.segmentId) {
        wt += +i.wt;
      }
    }
    return wt;
  }

  countCriticalWT(groupId, segmentId) {
    let wt = 0;
    for (let i of this.props.competeData) {
      if (groupId === i.groupId && segmentId === i.segmentId) {
        wt += +i.criticalCapacity[0].ccWt;
        if (i.criticalCapacity[1]) {
          wt += +i.criticalCapacity[1].ccWt;
        }
      }
    }
    return wt;
  }

  render() {
    let tabs = this.props.tabs.map((item, key) => {
      return (
        <li
          className="nav-item"
          key={`${item.groupId + `id` + item.segmentId}`}
          onClick={() => this.props.onTabChange(key)}
        >
          <a
            data-toggle="tab"
            className={
              key === this.props.tabStep ? "nav-link active show" : "nav-link"
            }
            href={`#${item.groupId + `id` + item.segmentId}`}
            aria-controls={`${item.groupId + `id` + item.segmentId}`}
            aria-selected="true"
          >
            {item.groupName + ` - ` + item.segmentName}
          </a>
        </li>
      );
    });

    let tabsContent = this.props.tabs.map((tabItem, key) => {
      let countWT = 0;
      let countCCWT = 0;
      let countScore = 0;
      let countConpenScore = [];

      const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId)
        .groupId;
      const segmentId = this.props.tabs.find(
        r => r.segmentId === tabItem.segmentId
      ).segmentId;

      return (
        <div
          id={groupId + `id` + segmentId}
          className={
            key === this.props.tabStep
              ? "tab-pane fade show active tabContentdiv compete-tab-content"
              : "tab-pane fade tabContentdiv compete-tab-content"
          }
          role="tabpanel"
          key={key}
        >
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12">
              {/* {this.props.tabs.map((item, key) => { */}
              <div className="compete-tab-content-box">
                <div className="project-name">
                  {this.props.challengeStatementData &&
                    this.props.challengeStatementData.Count > 0 &&
                    this.props.challengeStatementData.Items.map((name, key) => {
                      return <p>{name.chalange.horizon1.company}</p>;
                    })}
                </div>
                <table className="compete-capability-table">
                  <thead>
                    <tr>
                      <th>Benefits Sought</th>
                      <th>WT</th>
                      <th>Critical Capability</th>
                      <th>CC WT</th>
                      <th>
                        Rating <br /> (1-10)
                      </th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.competeData &&
                      !_.isEmpty(this.props.benefitsData) &&
                      this.props.competeData.map((i, index) => {
                        if (
                          groupId === i.groupId &&
                          segmentId === i.segmentId
                        ) {
                          let benefitName;
                          this.props.benefits.benefitsLadderData.Items[0].data.map(
                            item => {
                              if (item.groupId === i.groupId) {
                                benefitName = item.benefits.find(
                                  r => r.id === i.benefitId && r.important
                                );
                              }
                            }
                          );
                          // let benefitName = this.props.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);
                          return (
                            <tr>
                              <td>
                                <div className="td-box">{benefitName.name}</div>
                              </td>
                              <td>
                                <div className="td-box">
                                  <input
                                    className="wt-input"
                                    type="number"
                                    value={i.wt}
                                    onChange={e => this.props.onChangeWT(e, i)}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    return (
                                      <textarea
                                        disabled
                                        className={
                                          index === 0 ? "long-box capability-textarea" : "long-box capability-textarea"
                                        }
                                        type="text"
                                        value={critItem.text}
                                        onChange={e =>
                                          this.props.onChangeCriticalCapability(
                                            e,
                                            i,
                                            index
                                          )
                                        }
                                      />
                                    );
                                  })}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let ccWt =
                                      i.criticalCapacity.length > 1
                                        ? critItem.ccWt
                                        : critItem.ccWt;
                                    return (
                                      <input
                                        className="wt-input"
                                        type="number"
                                        value={ccWt}
                                        // onChange={(e)=>this.props.onChangeWT(e, i)}
                                      />
                                    );
                                  })}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let val = critItem.rating
                                      ? critItem.rating
                                      : "1";
                                    return (
                                      <select
                                        className="form-control"
                                        value={val}
                                        onChange={e =>
                                          this.props.onChangeRatingValue(
                                            e,
                                            i,
                                            index
                                          )
                                        }
                                        style={{ outline: "none" }}
                                      >
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                      </select>
                                    );
                                  })}
                                </div>
                              </td>
                              <td>
                                <div className="td-box">
                                  {i.criticalCapacity.map((critItem, index) => {
                                    let valScore = critItem.rating
                                      ? +critItem.ccWt * +critItem.rating
                                      : +critItem.ccWt;

                                    countScore = +countScore + valScore;
                                    return (
                                      <div className="score-box">
                                        {valScore}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      })}

                    <tr className="last-row">
                      <td />
                      <td className="first-value">
                        <strong>{this.countWT(groupId, segmentId)}</strong>
                      </td>
                      <td />
                      <td className="first-value">
                        <strong>
                          {this.countCriticalWT(groupId, segmentId)}
                        </strong>
                      </td>
                      <td />
                      <td className="first-value">
                        <strong>{countScore}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12">
              <div className="define-tab-content-box">
                <div className="row">
                  {!this.props.competeData.find(
                    r =>
                      r.groupId === tabItem.groupId &&
                      r.segmentId === tabItem.segmentId
                  ).competitorTotal &&
                    this.props.competitorsGroupsData.map((name, key) => {
                      if (name.important) {
                        return (
                          <div className="define-select-box">
                            <div className="form-group">
                              <select
                                className="form-control competiorsOptions"
                                style={{ height: "34px" }}
                                value={
                                  name.important ? name.competitorId : "select"
                                }
                                disabled
                                onChange={e =>
                                  this.props.onChangeCompetitors(e)
                                }
                              >
                                {this.props.competitorsGroupsData.map(
                                  (name, key) => {
                                    return (
                                      <option value={name.competitorId}>
                                        {name.competitorName}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                          </div>
                        );
                      }
                    })}
                  {this.props.competeData.find(
                    r =>
                      r.groupId === tabItem.groupId &&
                      r.segmentId === tabItem.segmentId
                  ).competitorTotal &&
                    _.uniqBy(
                      this.props.competeData.find(
                        r =>
                          r.groupId === tabItem.groupId &&
                          r.segmentId === tabItem.segmentId
                      ).competitorTotal,
                      "competitorId"
                    ).map((item, index) => {
                      return (
                        <div className="define-select-box">
                          <div className="form-group">
                            <select
                              className="form-control competiorsOptions"
                              style={{ height: "34px" }}
                              value={item.competitorId}
                              disabled
                              onChange={e => this.props.onChangeCompetitors(e)}
                            >
                              {this.props.competitorsGroupsData.map(
                                (name, key) => {
                                  return (
                                    <option value={name.competitorId}>
                                      {name.competitorName}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                        </div>
                      );
                    })}
                  <table className="compete-capability-table margin-top">
                    <thead>
                      <tr>
                        {this.props.competitorsGroupsData.map((name, key) => {
                          if (name.important) {
                            return (
                              <th className="parent-th">
                                <th className="child-th">
                                  Rating <br /> (1-10)
                                </th>
                                <th className="child-th">Score</th>
                              </th>
                            );
                          }
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.competeData && !_.isEmpty(this.props.benefitsData) &&
                        this.props.competeData.map((i, index) => {
                          if (groupId === i.groupId && segmentId === i.segmentId) {
                            return (
                              <tr>
                                {_.uniqBy( i.competitorTotal, "competitorId" ).map((competitorsData, key) => {
                                  return (
                                    <td className="parent-td">
                                      <td className="child-td">
                                        <div className="td-box">
                                          {i.criticalCapacity.map((critItem, index) => {
                                              let defData = critItem.competitors ? critItem.competitors.find( r => r.competitorId === competitorsData.competitorId ) : false;
                                              return (
                                                <select
                                                  className="form-control"
                                                  value={defData ? defData.rating : 1}
                                                  onChange={e => this.props.onChangeCompetitorsRatingValue( e,i,competitorsData,index ) }
                                                  style={{ outline: "none" }}
                                                >
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                  <option value="3">3</option>
                                                  <option value="4">4</option>
                                                  <option value="5">5</option>
                                                  <option value="6">6</option>
                                                  <option value="7">7</option>
                                                  <option value="8">8</option>
                                                  <option value="9">9</option>
                                                  <option value="10">10</option>
                                                </select>
                                              );
                                            }
                                          )}
                                        </div>
                                      </td>
                                      <td className="child-td">
                                        <div className="td-box">
                                          {i.criticalCapacity.map((critItem, index) => {
                                              let rateVal = critItem.competitors ? critItem.competitors.find(r =>r.competitorId === competitorsData.competitorId) : { rating: "1" };

                                              let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;

                                              countConpenScore.push({
                                                score: valScore,
                                                competitorId: competitorsData.competitorId
                                              });
                                              // countConpenScore = +countConpenScore + valScore;

                                              return (
                                                <div className="score-box">
                                                  {valScore
                                                    ? valScore
                                                    : critItem.ccWt}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </td>
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          }
                        })}
                      
                      <tr className="last-row">
                        { 
                            // let competeData = this.props.competeData.find(i => groupId === i.groupId && segmentId === i.segmentId)
                            _.uniqBy(this.props.competeData.find(i => groupId === i.groupId && segmentId === i.segmentId).competitorTotal, "competitorId" ).map((competitorsData, key) => {
                                let val = 0;
                              countConpenScore.map((item, key) => {
                                if (
                                  item.competitorId ===
                                  competitorsData.competitorId
                                ) {
                                  val = val + +item.score;
                                }
                              });
                              return (
                                <td className="parent-td">
                                  <td className="child-td" />
                                  <td className=" child-td first-value">
                                    <strong>{val}</strong>
                                  </td>
                                </td>
                              );
                            })
                           
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="criteria-tabs-content attractiveness-tab-content">
        <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
          {tabs}
          {/* { !_.isEmpty(this.props.attractivnessData.Items) && this.addTabs(this.props.attractivnessData.Items[0].data)} */}
        </ul>
        <div className="tab-content benefitsTabcontent" id="myTabContent">
          {tabsContent}
        </div>
      </div>
    );
  }
}
export default WeighBenefitsTabs;



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/RateBenefits/WeightBenefitsTabs/WeightBenefitsTabs.jsx